// ─────────────────────────────────────────────────────────
// MODEL: contentModel.js
// All static copy/content data for the site.
// Edit this file to update any text without touching components.
// ─────────────────────────────────────────────────────────

export const COMPANY = {
  name: 'Talentra',
  tagline: 'Connecting Great Talent with Great Teams',


  hours: 'Mon – Sat, 9:00 AM – 6:00 PM IST',
  call: '9811124156 , 7838815059',
  copyright: '© 2024 GuideMyWay. All rights reserved.',
};

export const ABOUT = {
  intro: [
    'Talentra is a specialized talent solutions partner focused on helping fast-growing startups and technology companies hire high-quality, interview-ready professionals with speed and precision.',
    'In today\'s competitive hiring landscape, finding the right talent is not just about volume — it\'s about relevance, quality, and timing. At Talentra, we combine targeted sourcing, structured screening, and a deep understanding of technical roles to deliver candidates who are genuinely aligned with our clients\' needs.',
    'We work closely with founders, hiring managers, and talent acquisition teams to simplify the recruitment process and reduce time-to-hire. Our approach is consultative, transparent, and results-driven, ensuring every engagement adds measurable value.',
  ],
  focus: [
    'Strategy & Consulting',
    'Leadership',
    'Data, AI & Advanced Analytics',
    'Core Technology & Digital Roles',
  ],
};

export const DIFFERENTIATORS = [
  {
    number: '1',
    title: 'We Understand Both Business & Talent',
    body: 'Unlike traditional recruitment firms that operate transactionally, we understand strategy, business priorities, and technical depth — allowing us to hire with context.',
  },
  {
    number: '2',
    title: 'Quality Over Volume',
    body: "We don't flood inboxes with profiles. Every candidate is curated, screened, and aligned before submission.",
  },
  {
    number: '3',
    title: 'Founder-Led Engagement',
    body: 'Every mandate is personally driven by the founders. No junior hand-offs. No diluted communication.',
  },
  {
    number: '4',
    title: 'Strategic Hiring, Not Resume Forwarding',
    body: 'We act as talent advisors — helping you define roles, structure teams, and think long-term.',
  },
  {
    number: '5',
    title: 'Network-Driven Search',
    body: 'Our access to strategy consultants, data leaders, and technology professionals allows us to tap into passive, high-quality talent pools.',
  },
];

export const TEAM_OVERVIEW = {
  title: 'Our Team',
  subtitle: 'Diverse Experience, Shared Excellence',
  description: [
    'Our core team brings diverse experience across recruitment, corporate environments, and consulting. With strong exposure to both client-side operations and advisory roles, the team has developed a deep understanding of evolving talent needs across industries.',
    'The team specializes in areas such as Strategy Consulting and Leadership Hiring, working closely with organizations to identify and place high-impact professionals in critical roles. By understanding business objectives and aligning the right talent strategies, the team focuses on delivering professionals who can create meaningful impact and drive measurable growth.',
    'With a combination of industry knowledge, recruitment expertise, and a relationship-driven approach, our team is committed to helping organizations build strong, high-performing teams.'
  ],
  strengths: [
    'Cross-industry recruitment expertise',
    'Strategy consulting background',
    'Leadership hiring specialization',
    'Relationship-driven approach',
    'Business-aligned talent strategies'
  ]
};

export const FOUNDERS = [
  {
    initials: 'PS',
    name: 'Pratyush Sharma',
    role: 'Co-Founder and CEO',
    focus: 'Technology Hiring & Candidate Strategy',
    bio: [
      'Pratyush Sharma is the Co-Founder and Chief Executive Officer of Talentra. He leads the company’s vision of building a focused and reliable talent solutions partner for fast-growing technology companies.',
'With a strong background in technology and a deep understanding of the developer ecosystem, Pratyush brings a unique perspective to recruitment,bridging the gap between technical teams and the talent they need to grow. His approach emphasizes quality sourcing, structured screening, and building long-term partnerships with both clients and candidates.',

'At Talentra, he oversees strategy, client partnerships, and the development of scalable recruitment processes aimed at helping startups and product teams hire the right talent efficiently.',

'Pratyush believes that successful hiring is not just about filling roles, but about connecting the right people with opportunities where they can truly create impact.'
    ],
  },
  {
    initials: 'H',
    name: 'Harshit',
    role: 'Co-Founder AND COO',
    focus: 'Strategy Consulting & Leadership Hiring',
    bio: [
      'After completing my B.Tech, I began my career in the EdTech industry as a Business Development Manager, where I developed strong expertise in sales, client relationships, and growth strategy. Over the next several years, I progressed into leadership roles, gaining valuable experience in team management, business expansion, and market development.',
      "I later transitioned into the real estate sector in a senior leadership role, which broadened my understanding of business operations, strategic growth, and industry dynamics. This journey eventually led me to start my own real estate firm, where I gained hands-on entrepreneurial experience.",
      "With diverse cross-industry exposure and a strong background in business development, I am now launching this recruitment venture with a clear vision—to connect the right talent with the right opportunities and help organizations build high-performing teams that drive long-term success.",
    ],
  },
  
  {
  initials: 'K',
  name: 'Komal ',
  role: 'Delivery Head',
  focus: 'Executive Search & Talent Strategy',
  bio: [
    'Komal brings diverse experience across recruitment, corporate environments, and consulting. With strong exposure to both client-side operations and advisory roles, she has developed a deep understanding of evolving talent needs across industries.',
    'She specializes in strategy consulting and leadership hiring, partnering with organizations to identify and place high-impact professionals in critical roles.',
    'By aligning talent strategies with business objectives, Komal focuses on delivering professionals who can drive meaningful impact and measurable growth.',
    'With a combination of industry knowledge, recruitment expertise, and a relationship-driven approach, she is committed to helping organizations build strong, high-performing teams.',
  ],
},
{
  initials: 'SR',
  name: 'Shubhanshu Rawat',
  role: 'Technical Head',
  focus: 'Platform Development & AI Engineering',
  bio: [
    'Shubhanshu leads the technical vision and development of the platform, ensuring scalable architecture and high-performance systems.',
    'With a strong background in software development, machine learning, and backend engineering, he focuses on building intelligent products that solve real-world problems.',
    'At Talentra, he is responsible for designing system architecture, implementing advanced AI-driven features, and ensuring the reliability and efficiency of the technology stack.',
    'He is passionate about leveraging modern technologies to build innovative solutions and drive continuous technical improvement.'
  ],
}
];

export const EXPERTISE_AREAS = [
  {
    icon: '📊',
    title: 'Strategy & Consulting Leadership',
    description:
      'We place strategy professionals, management consultants, and business transformation leaders who drive organisational growth. Our network spans top-tier consulting alumni and in-house strategy leaders across industries.',
    tags: ['Strategy Directors', 'Management Consultants', 'Business Analysts', 'Change Management', 'M&A Advisory'],
  },
  {
    icon: '🤖',
    title: 'Data, AI & Advanced Analytics',
    description:
      'We specialize in sourcing rare talent in data science, machine learning, and AI engineering. We understand the nuance between a data analyst and a machine learning engineer, and hire accordingly.',
    tags: ['Data Scientists', 'ML Engineers', 'AI Researchers', 'Analytics Leads', 'BI Specialists'],
  },
  {
    icon: '💻',
    title: 'Core Technology & Digital Roles',
    description:
      'From full-stack engineers to engineering leaders, we recruit across the entire technology stack. Our access to the developer ecosystem allows us to identify candidates who are technically strong and culturally aligned.',
    tags: ['Software Engineers', 'Full-Stack Developers', 'DevOps & Cloud', 'Product Managers', 'Engineering Managers', 'CTOs'],
    wide: true,
  },
];

export const HERO_STATS = [
  { value: '2,400+', label: 'Placements Made' },
  { value: '98%',    label: 'Client Satisfaction' },
  { value: '12 Days', label: 'Avg. Time-to-Hire' },
];
